import {Component, Input, ViewEncapsulation, inject} from '@angular/core';
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {DialogService} from "../../services/dialog.service";
import {DatePipe} from "@angular/common";
import {TYPE} from "../../types/types";
import {TranslatePipe} from "../../pipes/translate.pipe";
import {DocumentService} from "../../services/document.service";
import {FileSizePipe} from "../../pipes/file-size.pipe";
import {ContentComponent} from "../content/content.component";
import {IconBadgeComponent} from "../icon-badge/icon-badge.component";
import {FileStorageResource} from '../../types/settings-types/fileStorageResource';

@Component({
    selector: 'app-tooltip',
    imports: [
        TooltipModule,
        TranslatePipe,
        FileSizePipe,
        ContentComponent,
        DatePipe,
        IconBadgeComponent
    ],
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class TooltipComponent {
  public dialogService: DialogService = inject(DialogService);
  public documentService: DocumentService = inject(DocumentService);

  @Input() public text: string = '';
  @Input() public class: string = '';
  @Input() public iconClass: string = '';
  @Input() public width: string = '';
  @Input() public height: string = '';
  @Input() public icon: string = '';
  @Input() public opensOn: 'Click' | 'Auto' = 'Auto';
  @Input() public position: 'TopLeft' | 'TopCenter' | 'TopRight' | 'BottomLeft' | 'BottomCenter' | 'BottomRight' | 'LeftTop' | 'LeftCenter' | 'LeftBottom' | 'RightTop' | 'RightCenter' | 'RightBottom' = 'TopCenter'
  @Input() public cssClass: string = '';
  @Input() public type: 'Default' | 'Feedback' | 'Workflow' | 'File' = 'Default';
  @Input() public file: FileStorageResource | null = null;
  @Input() public feedbackListItem: TYPE.FeedbackListItem | null = null;
  @Input() public workflowListItem: TYPE.WorkflowListItem | null = null;
  @Input() public tooltipTarget: string = '';
  @Input() public windowCollision: boolean = true;
  @Input() public offsetY: number = 0;
  @Input() public offsetX: number = 0;

}
